import React, {useState} from 'react';

import './LandingHeader.scss';

import {Header, Nav, Navbar} from "rsuite";
import logo from'./icons/logo.svg';
import supportIcon from'./icons/support.svg';
const LandingHeader = (props) => {

    return (<div className="landing-header">
            <Header>
                <Navbar appearance="inverse">
                    <Navbar.Brand>
                        <a href='https://changaal.com/' >
                            <img src={logo}/>
                        </a>
                    </Navbar.Brand>
                </Navbar>
            </Header>


        </div>
    );
}

export default LandingHeader;